import { render, staticRenderFns } from "./ServerEdit.vue?vue&type=template&id=e9edb022&lang=html"
import script from "./ServerEdit.vue?vue&type=script&lang=js"
export * from "./ServerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports